export const fontSizing = {
  xs: {
    fontSize: "0.75rem",
    lineHeight: "1rem",
  },
  sm: {
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
  },
  base: {
    fontSize: "1rem",
    lineHeight: "1.5rem",
  },
  lg: {
    fontSize: "1.125rem",
    lineHeight: "1.75rem",
  },
  xl: {
    fontSize: "1.25rem",
    lineHeight: "1.75rem",
  },
  xxl: {
    fontSize: "1.5rem",
    lineHeight: "2rem",
  },
  xxxl: {
    fontSize: "1.875rem",
    lineHeight: "2.25rem",
  },
  t4xl: {
    fontSize: "2.25rem",
    lineHeight: "2.5rem",
  },
  t5xl: {
    fontSize: "3rem",
    lineHeight: "1",
  },
  t6xl: {
    fontSize: "3.75rem",
    lineHeight: "1",
  },
  t7xl: {
    fontSize: "4.5rem",
    lineHeight: "1",
  },
  t8xl: {
    fontSize: "6rem",
    lineHeight: "1",
  },
  t9xl: {
    fontSize: "8rem",
    lineHeight: "1",
  },
};
